import { useDealerByIdQuery } from "../features/dealers/queries/useDealersQuery";
import { DealerInterface } from "../interfaces/dealerInterface";

type Response = {
  data?: DealerInterface;
  isLoading: boolean;
};

export type UseDealerParams = {
  dealerId?: string;
};

export const useDealer = (opt: UseDealerParams): Response => {
  const { dealerId } = opt;
  const { data, isLoading } = useDealerByIdQuery(dealerId);
  return {
    data: data?.data,
    isLoading,
  };
};
